import React from 'react';
import {
  Datagrid,
  DeleteWithConfirmButton,
  EditButton,
  FunctionField,
  List,
  NumberField,
  TextField,
  TextInput,
} from 'react-admin';

const ArmyFilters = [
  <TextInput key="search" label="Search by Name" source="q" alwaysOn />
];

const ArmyList = () => (
  <List filters={ArmyFilters}>
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
    >
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="node" options={{ useGrouping: false }} />
      <TextField source="country" />
      <TextField source="faction" />
      <TextField source="general" />
      <FunctionField label="Added By" sortBy="added_by" render={(record) => record.added_by?.username || 'N/A'} />
      <FunctionField
        label="Status"
        sortBy="status" 
        render={(record) => {
          const getColor = (status) => {
            switch (status) {
              case 'enemy': return 'red';
              case 'friend': return 'green';
              case 'neutral': return 'grey';
              case 'scout': return 'orange';
              default: return 'black';
            }
          };
          return (
            <span
              style={{
                color: getColor(record.status),
                fontWeight: 'bold',
                textTransform: 'capitalize'
              }}
            >
              {record.status}
            </span>
          );
        }}
      />
      <EditButton />
      <DeleteWithConfirmButton
        mutationMode="undoable"
        confirmTitle="Confirm Deletion"
        confirmContent="Are you sure you want to delete this record? This action cannot be undone."
      />
    </Datagrid>
  </List>
);

export default ArmyList;
